import styled from 'styled-components/native';
import { ADMIN_COLORS } from '../../config/theme/adminColors';

/* Container principal — fundo neutro do painel admin, conteúdo centralizado.
   A UI da tela é montada com StyleSheet/Pressable no index.js (mesmo padrão das
   demais telas do admin), então aqui mantemos apenas o wrapper rolável. */
export const Container = styled.ScrollView.attrs({
  contentContainerStyle: {
    flexGrow: 1,
    backgroundColor: ADMIN_COLORS.surfaceSubtle,
    padding: 24,
    alignItems: 'center',
  },
})``;
